import React, { ReactNode } from 'react';

interface IProps {
  children: ReactNode;
  styles?: string;
}

const DEFAULT_STYLES = 'w-full h-full flex gap-2 place-content-start relative top-0';

const ContentWrapper = ({ children, styles }:IProps) => (
  <div className={styles || DEFAULT_STYLES}>
    {children}
  </div>
);

export default ContentWrapper;
